/*
 * Text { key: value } used for Filters.
 * Keys have no limitations
 */
const Text = {
  ADD_ATTRIBUTE: 'filter.text.addAttribute',
  ADD_ATTRIBUTES: 'filter.text.addAttributes',
  ADD_DATE: 'filter.text.addDate',
  ADD_EVENT: 'filter.text.addMilestone',
  ADD_LOCATION: 'filter.text.addStop',
  ADD_PROPERTY: 'filter.text.addProperty',
  CONNECTIVITY: 'filter.text.connectivity',
  CONNECTIVITY_SUBTITLE: 'filter.text.connectivitySubtitle',
  CURRENT_STATE: 'filter.text.currentState',
  CURRENT_STATE_SUBTITLE: 'filter.text.currentStateSubtitle',
  DATES: 'filter.text.dates',
  DATES_SUBTITLE: 'filter.text.datesSubtitle',
  EVENTS_AND_DATES: 'filter.text.milestones',
  EVENTS_AND_DATES_SUBTITLE: 'filter.text.milestonesSubtitle',
  ID_TYPE: 'filter.text.identifierType',
  ID_TYPE_SUBTITLE: 'filter.text.identifierTypeSubtitle',
  LOCATIONS: 'filter.text.routes',
  LOCATION: 'filter.text.route',
  LOCATION_SUBTITLE: 'filter.text.routeSubtitle',
  MODE_OF_SHIPMENT: 'filter.text.modeOfShipment',
  MODE_OF_SHIPMENT_SUBTITLE: 'filter.text.modeOfShipmentSubtitle',
  ORDER_PROPERTIES: 'filter.text.orderProperties',
  ORDER_PROPERTIES_SUBTITLE: 'filter.text.orderPropertiesSubtitle',
  ORDER_STATUS: 'filter.text.orderStatus',
  ORDER_STATUS_SUBTITLE: 'filter.text.orderStatusSubtitle',
  ORDER_TYPE: 'filter.text.orderType',
  ORDER_TYPE_SUBTITLE: 'filter.text.orderTypeSubtitle',
  PROPERTIES: 'filter.text.properties',
  PROPERTIES_SUBTITLE: 'filter.text.propertiesSubtitle',
  RELATED_ENTITY_ID: 'filter.text.relatedEntities',
  RELATED_ENTITY_SUBTITLE: 'filter.text.relatedEntitiesSubtitle',
  SEARCH_TEXT: 'filter.text.searchText',
  SELECT_ATTRIBUTE: 'filter.text.selectAttribute',
  SELECT_ATTRIBUTES: 'filter.text.selectAttributes',
  SELECT_DATE: 'filter.text.selectDate',
  SELECT_EVENT: 'filter.text.selectEvent',
  SELECT_LOCATION: 'filter.text.selectLocation',
  SELECT_PROPERTY: 'filter.text.selectProperty',
  SORT_BY: 'filter.text.sortBy',
};

/*
 * API { key: value } used for Filters.
 * Keys are specific to the body of their calls and must match expected Enums
 * Values are used in URL Params and must be unique to a Key for reverse lookup
 * Mappings for these POST bodies found in `context/FilterContext`
 */
const Connectivity = {
  DRIVER_DENY_TRACKING: 'filter.connectivity.driverDeniedTracking',
  MISSING_EQUIPMENT_IDENTIFIER:
    'filter.connectivity.missingEquipmentIdentifier',
  TRACKING_END_BY_USER: 'filter.connectivity.trackingEndedByUser',
  TRACKING_END_DUE_TO_TIMEOUT: 'filter.connectivity.trackingTimeout',
  TRACKING_FAILED: 'filter.connectivity.trackingFailed',
  TRACKING_START: 'filter.connectivity.trackingStarted',
  TRACKING_STOP: 'filter.connectivity.trackingStop',
  UNKNOWN_EQUIPMENT_IDENTIFIER:
    'filter.connectivity.unknownEquipmentIdentifier',
};

const CurrentState = {
  AT_STOP: 'filter.currentState.atStop',
  COMPLETED: 'filter.currentState.completed',
  IN_TRANSIT: 'filter.currentState.inTransit',
  SCHEDULED: 'filter.currentState.scheduled',
  UNKNOWN: 'filter.currentState.unknown',
};

const IdentifierType = {
  AIR_WAYBILL: 'filter.identifierType.airWaybill',
  BILL_OF_LADING: 'filter.identifierType.billOfLading',
  BOOKING_NUMBER: 'filter.identifierType.bookingNumber',
  CONTAINER_ID: 'filter.identifierType.containerId',
  HOUSE_AIR_WAYBILL: 'filter.identifierType.houseAirWaybill',
  ORDER: 'filter.identifierType.orderNumber',
  PRO: 'filter.identifierType.proNumber',
  RAIL_CAR_ID: 'filter.identifierType.railCarId',
  SERIAL_NUMBER: 'filter.identifierType.serialNumber',
  TRACKING_NUMBER: 'filter.identifierType.trackingNumber',
  TRAIN_NUMBER: 'filter.identifierType.trainNumber',
  VEHICLE_IDENTIFICATION_NUMBER:
    'filter.identifierType.vehicleIdentificationNumber',
  WAGON_ID: 'filter.identifierType.wagonId',
  WAYBILL: 'filter.identifierType.waybill',
};

const Milestones = {
  ACTUAL_DATETIME: 'filter.milestones.actualTime',
  ARRIVAL_AT_STOP: 'filter.milestones.arrival',
  AVAILABLE: 'filter.milestones.available',
  CONSIGNEE_NOTIFY: 'filter.milestones.consigneeNotified',
  DELIVERY: 'filter.milestones.delivery',
  DEPARTURE_FROM_STOP: 'filter.milestones.departure',
  DISCHARGE: 'filter.milestones.discharge',
  DISPATCH: 'filter.milestones.dispatch',
  ESTIMATED_DATETIME: 'filter.milestones.estimatedTime',
  EVENT_ADDRESS: 'filter.milestones.address',
  EVENT_AIRPORT_CODE: 'filter.milestones.airportCode',
  EVENT_CITY: 'filter.milestones.city',
  EVENT_COUNTRY: 'filter.milestones.country',
  EVENT_LOCATION_NAME: 'filter.milestones.locationName',
  EVENT_PORT_CODE: 'filter.milestones.portCode',
  EVENT_STATE: 'filter.milestones.state',
  EVENT_STOP_TYPE: 'filter.milestones.stopType',
  EVENT_ZIP: 'filter.milestones.zipcode',
  FLIGHT_BOOKING: 'filter.milestones.flightBooked',
  GATE_IN_EMPTY: 'filter.milestones.gateInEmpty',
  GATE_IN_FULL: 'filter.milestones.gateInFull',
  GATE_OUT_EMPTY: 'filter.milestones.gateOutEmpty',
  GATE_OUT_FULL: 'filter.milestones.gateOutFull',
  LOAD: 'filter.milestones.load',
  LOAD_ONTO_VEHICLE: 'filter.milestones.loadOntoVehicle',
  MANIFEST: 'filter.milestones.manifest',
  OUT_FOR_DELIVERY: 'filter.milestones.outForDelivery',
  PICKED_UP: 'filter.milestones.pickedUp',
  PLANNED_DATETIME: 'filter.milestones.plannedTime',
  RECEIVE_FROM_SHIPPER: 'filter.milestones.receivedFromShipper',
  RETURN_TO_SENDER: 'filter.milestones.returnedToSender',
  UNLOAD_FROM_VEHICLE: 'filter.milestones.unloadFromVehicle',
};

const ModeOfShipment = {
  AIR: 'filter.modeOfShipment.air',
  LTL: 'filter.modeOfShipment.ltl',
  MODE_OF_SHIPMENT_SCOPES: 'filter.modeOfShipment.modeOfShipmentScopes',
  OCEAN: 'filter.modeOfShipment.ocean',
  PARCEL: 'filter.modeOfShipment.parcel',
  RAIL: 'filter.modeOfShipment.rail',
  TRUCKLOAD: 'filter.modeOfShipment.truckload',
};

const Operators = {
  EQUALS: 'filter.operators.is',
  IN_THE_LAST: 'filter.operators.isInTheLast',
  IN_THE_NEXT: 'filter.operators.isInTheNext',
  NOT_EQUALS: 'filter.operators.isNot',
  RUNNING_EARLY: 'filter.operators.isEarlyBy',
  RUNNING_LATE: 'filter.operators.isLateBy',
  WITHIN: 'filter.operators.isBetween',
  CONTAINS: 'filter.operators.contains',
};

const OrderDates = {
  ORDER_DUE_DATE: 'filter.dates.orderDueDate',
  ORDER_SUBMISSION_DATE: 'filter.dates.orderSubmissionDate',
  SUPPLIER_READY_DATE: 'filter.dates.supplierReadyDate',
};

const OrderStatus = {
  ACCEPTED: 'filter.orderStatus.accepted',
  CANCELED: 'filter.orderStatus.canceled',
  FULFILLED: 'filter.orderStatus.fulfilled',
  PROCESSING: 'filter.orderStatus.processing',
  RECEIVED: 'filter.orderStatus.received',
  REJECTED: 'filter.orderStatus.rejected',
  SUBMITTED: 'filter.orderStatus.submitted',
};

export const OrderTags = {
  ORDER_TAG_ANALYST: 'filter.relatedEntities.analyst',
  ORDER_TAG_CARRIER: 'filter.relatedEntities.orderCarrier',
  ORDER_TAG_CATEGORY: 'filter.relatedEntities.category',
  ORDER_TAG_COMMODITY: 'filter.relatedEntities.commodity',
  ORDER_TAG_DEPARTMENT: 'filter.relatedEntities.department',
  ORDER_TAG_DIRECTOR: 'filter.relatedEntities.director',
  ORDER_TAG_FAMILY: 'filter.relatedEntities.family',
  ORDER_TAG_GROUP: 'filter.relatedEntities.group',
  ORDER_TAG_MANAGER: 'filter.relatedEntities.manager',
  ORDER_TAG_SECTOR: 'filter.relatedEntities.sector',
};

const Properties = {
  CARRIER: 'filter.properties.carrier',
  CARRIER_IATA: 'filter.properties.carrierIata',
  CARRIER_ICAO: 'filter.properties.carrierIcao',
  CARRIER_MC_NUMBER: 'filter.properties.carrierMcNumber',
  CARRIER_NAME: 'filter.properties.carrierName',
  CARRIER_SCAC: 'filter.properties.carrierScac',
  CARRIER_US_DOT_NUMBER: 'filter.properties.carrierUsDotNumber',
  IDENTIFIER: 'filter.properties.identifier',
  LICENSE_PLATE: 'filter.properties.licensePlate',
  RAIL_CAR_ID: 'filter.properties.railCarId',
  REFERENCE_KEY: 'filter.properties.referenceKey',
  TRAILER_ID: 'filter.properties.trailerId',
  VEHICLE_ID: 'filter.properties.vehicleId',
  VESSEL_CALL_SIGN: 'filter.properties.vesselCallSign',
  VESSEL_IMO: 'filter.properties.vesselImo',
  VESSEL_MMSI: 'filter.properties.vesselMmsi',
  VESSEL_NAME: 'filter.properties.vesselName',
  VESSEL_OR_VEHICLE_ID: 'filter.properties.vesselOrVehicleId',
  SHARED_VISIBILITY: 'filter.sharedVisibility.sharedVisibility',
  SHARING_RECIPIENT_TENANT_NAME: 'filter.sharedVisibility.sharedWith',
  SHARING_ORIGINATOR_TENANT_NAME:
    'filter.sharedVisibility.visibilityProvidedBy',
};

const RelatedEntities = {
  ADVANCED_SHIPMENT_NOTICE: 'filter.relatedEntities.advancedShipmentNotice',
  LOAD_ITEM_DESCRIPTION: 'filter.relatedEntities.description',
  LOAD_ITEM: 'filter.relatedEntities.loadItem',
  ORDER_DATE: 'filter.relatedEntities.orderDate',
  ORIGINAL_DELIVERY_START_DATETIME: 'filter.relatedEntities.orderDueDate',
  ORDER_IDENTIFIER: 'filter.relatedEntities.orderIdentifier',
  ORDER_IDENTIFIER_CONTRACT: 'filter.relatedEntities.contract',
  ORDER_IDENTIFIER_LOAD: 'filter.relatedEntities.orderLoad',
  ORDER_IDENTIFIER_MANUFACTURER: 'filter.relatedEntities.manufacturer',
  ORDER_IDENTIFIER_PROMOTION: 'filter.relatedEntities.promotion',
  ORDER_IDENTIFIER_SEASON: 'filter.relatedEntities.season',
  ORDER_IDENTIFIER_VENDOR: 'filter.relatedEntities.vendor',
  ORDER_TAGS: 'filter.relatedEntities.orderTags',
  PURCHASE_ORDER: 'filter.relatedEntities.purchaseOrder',
  SALES_ORDER: 'filter.relatedEntities.salesOrder',
  SKU: 'filter.relatedEntities.sku',
  SUPPLIER_READY_START_DATETIME: 'filter.relatedEntities.supplierReadyDate',
  UPC: 'filter.relatedEntities.upc',
  WAREHOUSE_MOVEMENT_ORDER: 'filter.relatedEntities.warehouseMovementOrder',
};

const Routes = {
  ALL_STOP: 'filter.routes.allStops',
  ANY_STOP: 'filter.routes.anyStop',
  CURRENT_STOP: 'filter.routes.currentStop',
  DESTINATION: 'filter.routes.destination',
  LOCATION_ADDRESS: 'filter.routes.address',
  LOCATION_AIRPORT_CODE: 'filter.routes.airportCode',
  LOCATION_CITY: 'filter.routes.city',
  LOCATION_COUNTRY: 'filter.routes.country',
  LOCATION_NAME: 'filter.routes.locationName',
  LOCATION_PORT_CODE: 'filter.routes.portCode',
  LOCATION_STATE: 'filter.routes.state',
  LOCATION_ZIP: 'filter.routes.zipcode',
  ORIGIN: 'filter.routes.origin',
  STOP_TYPE: 'filter.routes.stopType',
};

const Sort = {
  ACT_OR_EST_DELIVERY_DATETIME: 'estimated_actual_arrival',
  ACT_OR_EST_DELIVERY_DELTA: 'estimated_actual_arrival_delay',
  ASC: 'asc',
  CREATED_DATETIME: 'recently_created',
  DEPART_ABS_ORIGIN_ACT_OR_EST_DATETIME: 'estimated_actual_departure',
  DEPART_ABS_ORIGIN_ACT_OR_EST_DELTA: 'estimated_actual_departure_delay',
  DEPART_ABS_ORIGIN_PLANNED_DATETIME: 'planned_departure',
  DEPART_FIRST_POL_ACT_OR_EST_DATETIME: 'poo_estimated_actual_departure',
  DEPART_FIRST_POL_ACT_OR_EST_DELTA: 'poo_estimated_actual_departure_delay',
  DEPART_FIRST_POL_PLANNED_DATETIME: 'poo_planned_departure',
  DISCHARGE_LAST_POD_ACT_OR_EST_DATETIME: 'pod_estimated_actual_arrival',
  DISCHARGE_LAST_POD_EST_DELTA: 'pod_estimated_actual_arrival_delay',
  DISCHARGE_LAST_POD_PLANNED_DATETIME: 'pod_planned_arrival',
  DESC: 'desc',
  ORDER_SUBMISSION_DATETIME: 'orderSubmissionDateTime',
  ORIGINAL_DELIVERY_WINDOW_END_DATETIME:
    'originalDeliveryDateTimeWindow.endDateTime',
  PLANNED_DELIVERY_DATETIME: 'planned_arrival',
  SUPPLIER_READY_WINDOW_END_DATETIME: 'supplierReadyDateTimeWindow.endDateTime',
  UPDATED_DATETIME: 'recently_updated',
};

const Suggestions = {
  ATTRIBUTE_KEY: 'filter.suggestions.attributeKey',
  ATTRIBUTE_VALUE: 'filter.suggestions.attributeValue',
  DESTINATION_ADDRESS: 'filter.suggestions.destinationAddress',
  DESTINATION_AIRPORT_CODE: 'filter.suggestions.destinationAirportCode',
  DESTINATION_CITY: 'filter.suggestions.destinationCity',
  DESTINATION_COUNTRY: 'filter.suggestions.destinationCountry',
  DESTINATION_LOCATION_NAME: 'filter.suggestions.destinationLocationName',
  DESTINATION_PORT_CODE: 'filter.suggestions.destinationPortCode',
  DESTINATION_STATE: 'filter.suggestions.destinationState',
  DESTINATION_ZIP: 'filter.suggestions.destinationZip',
  ORDER_ATTRIBUTE_KEY: 'filter.suggestions.orderAttributeKey',
  ORDER_ATTRIBUTE_VALUE: 'filter.suggestions.orderAttributeValue',
  ORDER_REFERENCE_KEY: 'filter.suggestions.orderReferenceKey',
  ORIGIN_ADDRESS: 'filter.suggestions.originAddress',
  ORIGIN_AIRPORT_CODE: 'filter.suggestions.originAirport',
  ORIGIN_CITY: 'filter.suggestions.originCity',
  ORIGIN_COUNTRY: 'filter.suggestions.originCountry',
  ORIGIN_LOCATION_NAME: 'filter.suggestions.originLocationName',
  ORIGIN_PORT_CODE: 'filter.suggestions.originPortCode',
  ORIGIN_STATE: 'filter.suggestions.originState',
  ORIGIN_ZIP: 'filter.suggestions.originZipcode',
  STOP_ADDRESS: 'filter.suggestions.stopAddress',
  STOP_AIRPORT_CODE: 'filter.suggestions.stopAirportCode',
  STOP_CITY: 'filter.suggestions.stopCity',
  STOP_COUNTRY: 'filter.suggestions.stopCountry',
  STOP_LOCATION_NAME: 'filter.suggestions.stopLocationName',
  STOP_PORT_CODE: 'filter.suggestions.stopPortCode',
  STOP_STATE: 'filter.suggestions.stopState',
  STOP_ZIP: 'filter.suggestions.stopZip',
};

const filter_dictionary: { [key: string]: string } = {
  ...Connectivity,
  ...CurrentState,
  ...IdentifierType,
  ...Milestones,
  ...ModeOfShipment,
  ...Operators,
  ...OrderDates,
  ...OrderStatus,
  ...OrderTags,
  ...Properties,
  ...RelatedEntities,
  ...Routes,
  ...Sort,
  ...Suggestions,
  ...Text,
};

export default filter_dictionary;
